import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const firestoreDatabaseId = import.meta.env.VITE_FIRESTORE_DATABASE_ID || 'fitstac-db';
export const db = getFirestore(app, firestoreDatabaseId);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Production builds force `VITE_USE_EMULATORS=false` in package.json, so local
// environments can trust this flag without trying to infer "localness" from the host.
const wantsEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';
const emulatorHost = import.meta.env.VITE_FIREBASE_EMULATOR_HOST || 'localhost';
const authEmulatorPort = Number(import.meta.env.VITE_FIREBASE_EMULATOR_AUTH_PORT || 9099);
const firestoreEmulatorPort = Number(import.meta.env.VITE_FIREBASE_EMULATOR_FIRESTORE_PORT || 8085);
const functionsEmulatorPort = Number(import.meta.env.VITE_FIREBASE_EMULATOR_FUNCTIONS_PORT || 5001);
const storageEmulatorPort = Number(import.meta.env.VITE_FIREBASE_EMULATOR_STORAGE_PORT || 9199);
const useEmulators = wantsEmulators;

if (useEmulators) {
  console.log('🔧 Using Firebase Emulators');
  connectAuthEmulator(auth, `http://${emulatorHost}:${authEmulatorPort}`, { disableWarnings: true });
  connectFirestoreEmulator(db, emulatorHost, firestoreEmulatorPort);
  connectFunctionsEmulator(functions, emulatorHost, functionsEmulatorPort);
  connectStorageEmulator(storage, emulatorHost, storageEmulatorPort);
}

export default app;
